import { render, staticRenderFns } from "./basePurchase.vue?vue&type=template&id=44b37870&scoped=true"
import script from "./basePurchase.vue?vue&type=script&lang=js"
export * from "./basePurchase.vue?vue&type=script&lang=js"
import style0 from "./basePurchase.vue?vue&type=style&index=0&id=44b37870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b37870",
  null
  
)

export default component.exports